import React from 'react';
import PropTypes from 'prop-types';
import { PLACEHOLDER_COLOR } from '../../../styles/variables';

const TrashIcon = ({ color, size }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30">
      <defs>
        <path
          id="TrashIconA"
          d="M11 5c0-1.605 1.047-3 2.5-3h3C17.953 2 19 3.395 19 5h3a2 2 0 0 1 2 2v1h1a1 1 0 0 1 0 2h-1v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V10H5a1 1 0 1 1 0-2h1V7a2 2 0 0 1 2-2h3zm2 0h4c0-.605-.297-1-.5-1h-3c-.203 0-.5.395-.5 1zM8 8h14V7H8v1zm14 2H8v16h14V10zm-12 2a1 1 0 0 1 2 0v12a1 1 0 0 1-2 0V12zm8 0a1 1 0 0 1 2 0v12a1 1 0 0 1-2 0V12zm-4 0a1 1 0 0 1 2 0v12a1 1 0 0 1-2 0V12z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="TrashIconB" fill="#fff">
          <use xlinkHref="#TrashIconA" />
        </mask>
        <use fill={color || PLACEHOLDER_COLOR} fillRule="nonzero" xlinkHref="#TrashIconA" />
        <g fill={color || PLACEHOLDER_COLOR} mask="url(#TrashIconB)">
          <path d="M0 0h30v30H0z" />
        </g>
      </g>
    </svg>
  );
};

TrashIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

TrashIcon.defaultProps = {
  color: PLACEHOLDER_COLOR,
  size: '30px',
};

export default TrashIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Trash/index.js